<template>
    <div>
        <card-header title="Reseller Quotes" icon="fa-file-invoice-dollar"/>

        <card-toolbar>
            <button @click="$openCard('new-reseller-quote', {}, card)"><i class="far fa-plus"></i>New Quote</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <navigation-list-item
                    title="Completed Quotes"
                    icon="fa-file-check"
                    :active="child && child.definition.component === 'completed-quotes'"
                    @click="$openCard('completed-quotes', {}, card)"
                />
                <template v-if="currentUser.role === 'dev' || currentUser.role === 'admin'">
                    <subheader-list-item title="Pending Quotes" icon="fa-history" :badge="pendingQuotes.length"/>
                    <quote-tile
                        v-for="quote in pendingQuotes"
                        :card="card"
                        :quote="quote"
                        :active="child && child.definition.component === 'edit-reseller-quote' && parseInt(child.props.quoteId) === quote.id"
                        @click="$openCard('edit-reseller-quote', {quoteId: quote.id}, card)"/>
                </template>
                <template v-else>
                    <subheader-list-item title="Pending Quotes" icon="fa-history" :badge="pendingQuotes.length"/>
                    <quote-tile
                        v-for="quote in pendingQuotes"
                        :card="card"
                        :quote="quote"
                        :clickable="false"
                    />
                </template>

                <subheader-list-item title="Cart Enrollments" icon="fa-shopping-cart" :badge="cartQuotes.length"/>
                <quote-tile
                    v-for="quote in cartQuotes"
                    :card="card"
                    :quote="quote"
                    :clickable="false"
                />

                <subheader-list-item title="Open Quotes" icon="fa-pencil" :badge="draftQuotes.length"/>
                <quote-tile
                    v-for="quote in draftQuotes"
                    :card="card"
                    :quote="quote"
                    :active="child && child.definition.component === 'edit-reseller-quote' && parseInt(child.props.quoteId) === quote.id"
                    @click="$openCard('edit-reseller-quote', {quoteId: quote.id}, card)"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import QuoteTile from "@/components/tiles/QuoteTile";

    import {client as http} from '../../http_client';
    import {mapGetters} from "vuex";
    import NavigationListItem from "../../TIER/components/NavigationListItem";

    export default {
        components: {NavigationListItem, QuoteTile, CardHeader, CardBody, CardToolbar, CardList, SubheaderListItem},
        props: ['card', 'child'],
        data() {
            return {
                quotes: []
            }
        },
        computed: {
            ...mapGetters(['currentUser']),
            cartQuotes: function() {
                let a = [];
                for (let i = 0; i < this.quotes.length; i++) {
                    const quote = this.quotes[i];
                    if (quote.status === 'CART') a.push(quote);
                }
                return a;
            },
            draftQuotes: function() {
                let a = [];
                for (let i = 0; i < this.quotes.length; i++) {
                    const quote = this.quotes[i];
                    if (quote.status === 'DRAFT' || quote.status === 'REVIEW') a.push(quote);
                }
                return a;
            },
            pendingQuotes: function() {
                let a = [];
                for (let i = 0; i < this.quotes.length; i++) {
                    const quote = this.quotes[i];
                    if (quote.status === 'SUBMITTED') a.push(quote);
                }
                return a;
            }
        },
        methods: {
            loadQuotes: function (force) {
                this.$emit('loading', true);

                http.get('quotes/pending', {force}).then(response => {
                    this.quotes = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function () {
                this.loadQuotes(true);
            }
        },
        mounted: function () {
            this.loadQuotes();
        }
    }
</script>
